import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Button, Space, Table } from "antd";
import React, { useState } from "react";

import conditional from '../../tools/conditional';
import Renderer from '../Renderer';
import InnerExpandedTable from "./InnerExpandedTable";

export default function PrefixMissingData(props){
    const {
        loading = false,
        setLoading = () => {},
        getDrilldown = () => {},
        supplier = "",
        group = "",
        prefixPageData = {},
        isbnValues = {},
        dataValues = {},        
    } = props

    const [expanded, setExpanded] = useState([]);

    const columns = [
        {
            title: <small>Pubdate</small>,  width: '100px', dataIndex: 'prefix', key: 'prefix', render: (e, f) => {
                return <>
                <Space>
                    <span style={{"fontWeight": "800", "fontSize": "14px"}}>{f.prefix}
                        <Button 
                            onClick={() => expandCell(f.prefix)} 
                            size="small" 
                            type="text" 
                            icon={
                                <small>
                                    <conditional.true value={expanded.includes(f.prefix)}>
                                        <CaretUpOutlined style={{ "fontSize": "14px" }} />    
                                    </conditional.true>
                                    <conditional.true value={!expanded.includes(f.prefix)}>
                                        <CaretDownOutlined style={{ "fontSize": "14px" }} />   
                                    </conditional.true>
                                </small>
                            } 
                        /> 
                    </span>
                </Space>
                </>
            }
        },
    ]

    //all isbn values
    if(isbnValues.all_isbns){
        columns.push({
            title: <small>All ISBNs</small>, width: "50px", dataIndex: 'all_isbns', key:'all_isbns',  render: (e, f) => {
                return <span className="isbnCount" style={{ "cursor": "pointer"}} onClick={() => getDrilldown(f.prefix, group, "all_isbns", f.all_isbns)}>{f.all_isbns}</span>
            }
        })
    }

    //ranked isbn values
    if(isbnValues.rank_isbns){
        columns.push({
            title: <small>Rank ISBNs</small>, width: "50px", dataIndex: 'rank_isbns', key:'rank_isbns',  render: (e, f) => {
                return <span className="isbnCount" style={{ "cursor": "pointer"}} onClick={() => getDrilldown(f.prefix, group, "rank_isbns", f.rank_isbns)}>{f.rank_isbns}</span>
            }
        })
    }
    
    //nyr isbn values
    if(isbnValues.nyr_isbns){
        columns.push({
            title: <small>NYR ISBNs</small>, width: "50px", dataIndex: 'nyr_isbns', key:'nyr_isbns',  render: (e, f) => {
                return <span className="isbnCount" style={{ "cursor": "pointer"}} onClick={() => getDrilldown(f.prefix, group, "nyr_isbns", f.nyr_isbns)}>{f.nyr_isbns}</span>
            }
        })
    }

    //oh isbn values
    if(isbnValues.oh_isbns){
        columns.push({
            title: <small>OH ISBNs</small>, width: "50px", dataIndex: 'oh_isbns', key:'oh_isbns',  render: (e, f) => {
                return <span className="isbnCount" style={{ "cursor": "pointer"}} onClick={() => getDrilldown(f.prefix, group, "oh_isbns", f.oh_isbns)}>{f.oh_isbns}</span>
            }
        })
    }

    //oo isbn values
    if(isbnValues.oo_isbns){
        columns.push({
            title: <small>OO ISBNs</small>, width: "50px", dataIndex: 'oo_isbns', key:'oo_isbns',  render: (e, f) => {
                return <span className="isbnCount" style={{ "cursor": "pointer"}} onClick={() => getDrilldown(f.prefix, group, "oo_isbns", f.oo_isbns)}>{f.oo_isbns}</span>
            }
        })
    }

    //ito isbn values
    if(isbnValues.ito_isbns){
        columns.push({
            title: <small>ITO ISBNs</small>, width: "50px", dataIndex: 'ito_isbns', key:'ito_isbns',  render: (e, f) => {
                return <span className="isbnCount" style={{ "cursor": "pointer"}} onClick={() => getDrilldown(f.prefix, group, "ito_isbns", f.ito_isbns)}>{f.ito_isbns}</span>
            }
        })
    }


    




    const drawChildTable = (record) => {
        return (
            <>
                <div className="hideHover" style={{ "margin": "-7px" }}>
                    <div style={{ "padding": "0px 15px" }}>
                        <Renderer close={false}><InnerExpandedTable
                            record={record}
                            isbnValues={isbnValues}
                            dataValues={dataValues}
                            setLoading={setLoading}
                            getDrilldown={getDrilldown}
                            supplier={supplier}
                            group={group}
                            loading={loading}
                        ></InnerExpandedTable></Renderer>
                    </div>
                    <div className="shim" /><div className="shim" />
                </div>
            </>
        )
    }

    const expandCell = (_data, _index) => {
        if (!expanded.includes(_data)) {
            setExpanded([_data]);
        } else {
            setExpanded([]);
        }
    }

    const expandable = {
        rowExpandable: (record) => expanded.find((element) => element === record.prefix),
        expandedRowKeys: expanded,
        expandIconColumnIndex: -1,
        onExpand: (e) => {return false},
        expandIcon: <></>,
        expandedRowRender: (record) => drawChildTable(record)
    };

    return(
        <>
            <div style={{ "padding": "0px 0px" }}>
                <div style={{ "margin": "0 0px", "width": "100%" }}>
                    <Table
                        scroll={{x: 'max-content'}}
                        size="small"
                        loading={loading}
                        bordered
                        columns={columns}
                        dataSource={prefixPageData}
                        className="missingDataTable"
                        rowKey={(record)=> record.prefix}
                        pagination={{
                            defaultPageSize: 50,
                            showSizeChanger: true,
                            position: ['topRight', 'bottomRight'],
                        }}
                        expandable={expandable}
                    />
                </div>
            </div>
        </>
    )
}